import { AnimatePresence, motion } from "motion/react";
import { useEffect, useState } from "react";
import LoadingSpinner from '../Spinner';
import { Flip, ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "./toastify/config";
import apiCumbres from "../axios/axios";
import Swal from "sweetalert2";
import { useSelector } from 'react-redux';
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField } from "@mui/material";
import Tooltip from "./Tooltip";
import EditSquareIcon from '@mui/icons-material/EditSquare';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ModalEditCliente from "./ModalEditCliente";
import { sxTableHead, textFieldStyle } from "./Styles";


const ListadoClientes = () => {
    const tkn = useSelector((state) => state.tknAuth)
    const [isLoading, setIsLoading] = useState(false)
    const [catClientes, setCatClientes] = useState([])
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [search, setSearch] = useState("");
    const [modalEditCopen, setModalEditCopen] = useState(false)
    const [idClienteEdit, setIdClienteId] = useState(false);

    const obtenerClientes = () => {

        const obtener = async () => {

            setIsLoading(true)
            try {

                const clientes = await apiCumbres.get('/clientes/obtener')

                setCatClientes(clientes.data)
                setIsLoading(false)
            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    console.log(error.response)
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error obtener catalogo de clientes, favor de volver a recargar!'
                    }
                } else {
                    console.log(error)
                    msg_error = 'No hay respuesta por parte del servidor!'
                }
                //mensaje de toastify
                setIsLoading(false)
                toast.error(msg_error, toast_config)
            }

        }

        obtener()

    }

    useEffect(() => {
        obtenerClientes()
    }, [])

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const filteredClientes = catClientes.filter(cli =>
        `${cli.nombre} ${cli.paterno ?? ""} ${cli.materno ?? ""}`
            .toLowerCase()
            .includes(search.toLowerCase())
    );

    const accionCliente = (e, accion, id) => {

        if (['desactivar', 'activar'].includes(accion)) {

            Swal.fire({
                title: "Está seguro?",
                text: `Se ${accion}á cliente!`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: `Si, ${accion}!`
            }).then((result) => {
                if (!result.isConfirmed) return

                const estatus = async () => {
                    try {
                        setIsLoading(true)
                        const cambiarActivo = await apiCumbres.put(`/clientes/cambiar-activo/${id}`)
                        setIsLoading(false)

                        Swal.fire({
                            icon: 'success',
                            title: 'Enhorabuena!',
                            text: cambiarActivo.data.mensaje
                        }).then((result) => {
                            window.location.href = '/clientes'
                        })



                    } catch (error) {
                        let msg_error = ''
                        if (error.response) {
                            console.log(error.response)
                            if (error.response.data.error) {
                                msg_error = error.response.data.error
                            } else {
                                msg_error = 'Ocurrió un error al cambiar estatus a cliente, favor de volver a recargar!'
                            }
                        } else {
                            console.log(error)
                            msg_error = 'No hay respuesta por parte del servidor!'
                        }
                        //mensaje de toastify
                        setIsLoading(false)
                        toast.error(msg_error, toast_config)
                    }
                }

                estatus()



            });

        } else {
            setIdClienteId(id)
            //editar
            setModalEditCopen(true)
        }

    }

    return (
        <motion.div layout className="container mb-5" >
            {isLoading ?
                <LoadingSpinner />
                : null}
            <motion.div layout className="row">
                <div className="col-md-12">
                    <AnimatePresence>
                        <motion.div
                            layout
                            key="form-card"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0, y: -30 }}   // ⬅️ efecto de salida de la tarjeta completa
                            transition={{ duration: 0.4, ease: "easeInOut" }}
                        >
                            <div
                                className="card shadow-lg  p-5 border-0"
                                style={{ borderRadius: '20px' }}
                            >
                                <div className="row">
                                    <motion.h1 className="color-primary"
                                        initial={{ opacity: 0, y: -90 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        exit={{ opacity: 0, y: -20 }}
                                        transition={{ duration: 0.5, ease: "easeOut", delay: 0.3 }}>
                                        Listado de Clientes
                                    </motion.h1>
                                    <hr className="mb-5" />
                                    <motion.div
                                        key={page}
                                        initial={{ opacity: 0, y: 40 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.5, ease: "easeOut", delay: 0.4 }}

                                    >
                                        <TextField
                                            label="Buscar cliente por nombre"
                                            variant="outlined"
                                            size="small"
                                            className="mb-3"
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                            sx={textFieldStyle}
                                        />

                                        <TableContainer component={Paper} sx={{ overflowX: "auto" }}>
                                            <Table >
                                                <TableHead>
                                                    <TableRow sx={{ backgroundColor: "#0a2540" }}>
                                                        <TableCell sx={sxTableHead}>#</TableCell>
                                                        <TableCell sx={sxTableHead}>Nombre</TableCell>
                                                        <TableCell sx={sxTableHead}>Direccion</TableCell>
                                                        <TableCell sx={sxTableHead}>Telefeno</TableCell>
                                                        <TableCell sx={sxTableHead}>Notas</TableCell>
                                                        <TableCell sx={sxTableHead}>Correo</TableCell>
                                                        <TableCell sx={sxTableHead}>Activo</TableCell>
                                                        <TableCell sx={sxTableHead}>Acciones</TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    <AnimatePresence component={null}>
                                                        {filteredClientes
                                                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((cli, index) => (
                                                                <motion.tr
                                                                    key={index}
                                                                    initial={{ opacity: 0, x: -50 }}
                                                                    animate={{ opacity: 1, x: 0 }}
                                                                    exit={{ opacity: 0, y: -40 }}
                                                                    transition={{
                                                                        duration: 0.4,
                                                                        ease: "easeOut",
                                                                        delay: 0.1 * index
                                                                    }}
                                                                    style={{
                                                                        backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff"
                                                                    }}
                                                                >
                                                                    <TableCell >{page * rowsPerPage + index + 1}</TableCell>
                                                                    <TableCell >{cli.nombre}{cli.paterno ? ' ' + cli.paterno : ''}{cli.materno ? ' ' + cli.materno : ''}</TableCell>
                                                                    <TableCell>{cli.direccion}</TableCell>
                                                                    <TableCell>{cli.telefono}</TableCell>
                                                                    <TableCell>{cli.notas}</TableCell>
                                                                    <TableCell>{cli.correo}</TableCell>
                                                                    <TableCell sx={{ color: cli.activo === '0' ? 'red' : 'green' }}>
                                                                        {cli.activo === '0' ? 'DESACTIVADO' : 'ACTIVADO'}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <Tooltip text={'EDITAR'} position="left">
                                                                            {cli.activo === '1' ? (
                                                                                <EditSquareIcon className="text-primary pointer" onClick={(e) => accionCliente(e, 'editar', cli.clienteId)} />

                                                                            ) : (
                                                                                null
                                                                            )}

                                                                        </Tooltip>
                                                                        {![1, 4].includes(tkn.rolId) ? 
                                                                            null : (
                                                                            cli.activo === '1' ? (
                                                                                <Tooltip text={'DESACTIVAR'} position="left">
                                                                                    <DeleteIcon className="text-danger pointer" onClick={(e) => accionCliente(e, 'desactivar', cli.clienteId)} />
                                                                                </Tooltip>

                                                                            ) : (
                                                                                <Tooltip text={'ACTIVAR'} position="left">
                                                                                    <CheckCircleIcon className="text-success pointer" onClick={(e) => accionCliente(e, 'activar', cli.clienteId)} />
                                                                                </Tooltip>
                                                                            ))
                                                                        }

                                                                    </TableCell>

                                                                </motion.tr>
                                                            ))}
                                                    </AnimatePresence>
                                                </TableBody>
                                            </Table>
                                            <TablePagination
                                                component="div"
                                                count={filteredClientes.length}
                                                page={page}
                                                onPageChange={handleChangePage}
                                                rowsPerPage={rowsPerPage}
                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                                labelRowsPerPage="Registros por página"
                                                rowsPerPageOptions={[5, 10, 25, 50]}
                                            />
                                        </TableContainer>
                                    </motion.div>
                                </div>
                            </div>
                        </motion.div>
                    </AnimatePresence>
                </div>



            </motion.div>

            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />
            
                <ModalEditCliente
                    open={modalEditCopen}
                    onClose={() => setModalEditCopen(false)}
                    ic={idClienteEdit}
                />
        </motion.div>
    )

}

export default ListadoClientes